/**
 * Recursively traverses an array of tree items and applies a callback to each item.
 *
 * @template T - Type of the tree item, extending the TreeItem interface.
 * @param {T[]} treeItems - The array of tree items to walk through.
 * @param {(treeItem: T) => void} callback - The callback function to apply to each tree item.
 * @returns {void} This function does not return a value.
 */
export function walkTreeItems(treeItems, callback) {
    for (const item of treeItems) {
        callback(item);
        if (item.children) {
            walkTreeItems(item.children, callback);
        }
    }
}
